module.exports = __webpack_public_path__ + "static/media/quick_quote_icon.0bc4c3e5.svg";